import ActivitiesCollection from 'ef/collections/activities_collection';
import ActivityProgressesCollection from 'ef/collections/activity_progresses_collection';
import AnswersCollection from 'ef/collections/answers_collection';
import CustomizationsCollection from 'ef/collections/customizations_collection';
import GroupCollection from 'ef/collections/group_collection';
import LocationsCollection from 'ef/collections/locations_collection';
import ModulesCollection from 'ef/collections/modules_collection';
import PagesCollection from 'ef/collections/pages_collection';
import Questions from 'ef/collections/questions';
import QuestionsCollection from 'ef/collections/questions_collection';
import ResourcesCollection from 'ef/collections/resources_collection';
import ResponsesCollection from 'ef/collections/responses_collection';
import SectionsCollection from 'ef/collections/sections_collection';

import AssessmentsAnswersCollection from 'ef/collections/assessments/answers_collection';
import AssessmentsQuestionsCollection from 'ef/collections/assessments/questions_collection';
import EvaluationsResponseSetCollection from 'ef/collections/evaluations/response_set_collection';

export default {
  ActivitiesCollection,
  ActivityProgressesCollection,
  AnswersCollection,
  CustomizationsCollection,
  GroupCollection,
  LocationsCollection,
  ModulesCollection,
  PagesCollection,
  Questions,
  QuestionsCollection,
  ResourcesCollection,
  ResponsesCollection,
  SectionsCollection,
  Assessments: {
    AnswersCollection: AssessmentsAnswersCollection,
    QuestionsCollection: AssessmentsQuestionsCollection,
  },
  Evaluations: { ResponseSetCollection: EvaluationsResponseSetCollection },
};
